module.exports = __webpack_public_path__ + "static/199_special.ae964cbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/img/199_special.jpg
// module id = 641
// module chunks = 35783957827783